import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import style from "./style";

class HiringCard extends Component {
  render() {
    const { t, position } = this.props;
    const {
      textsContainerStyle,
      cardTitle,
      iconaSocialStyle,
      cardContainerStyle,
      cardContentStyle,
      cardContentHeadings,
      containerContentStyle,
    } = style;
    const keys = [
      "contenuto1",
      "contenuto2",
      "contenuto3",
      "contenuto4",
      "contenuto5",
    ];

    const offerKeys = ["contenuto7", "contenuto8"];

    return (
      <>
        <div style={cardContainerStyle}>
          <div style={textsContainerStyle}>
            <div style={cardTitle}>{t("positions:title")}</div>
          </div>
          <img alt="icon" src={position.icon} style={iconaSocialStyle}></img>
        </div>
        <div style={containerContentStyle}>
          <div
            style={cardContentStyle}
            dangerouslySetInnerHTML={{ __html: t("positions:content") }}
          ></div>
        </div>
        <div style={{ display: "flex", padding: "0px 20px" }}>
          <div style={cardContentHeadings}>{t("positions:heading")}</div>
        </div>
        <div style={{ display: "flex", padding: "0px 20px 0 0" }}>
          <ul>
            {keys.map((key) => (
              <li
                style={cardContentStyle}
                dangerouslySetInnerHTML={{ __html: t(`positions:${key}`) }}
              ></li>
            ))}
          </ul>
        </div>
        <div style={{ display: "flex", padding: "0px 20px" }}>
          <div style={cardContentHeadings}>{t("positions:contenuto6")}</div>
        </div>
        <div style={{ display: "flex", padding: "0px 20px 0 0" }}>
          <ul>
            {offerKeys.map((key) => (
              <li
                style={cardContentStyle}
                dangerouslySetInnerHTML={{ __html: t(`positions:${key}`) }}
              ></li>
            ))}
          </ul>
        </div>
      </>
    );
  }
}
export default withTranslation("HiringCard")(HiringCard);
